import {VeriflytResultFragmentFragment, VeriflytResultStatus} from "../../../../../../__generated__/graphql/types";
import ETable from "../../../../../enchanced-antd-table";
import {ColumnProps} from "antd/lib/table";
import {Icon, Typography} from "antd";
import {momentOrNull} from "../../../../../../common/util";
import moment from "moment";
import React from "react";

type FailingDetail = VeriflytResultFragmentFragment['failingDetails'][0]
type PassingDetail = VeriflytResultFragmentFragment['passingDetails'][0]

type StatusDetail = FailingDetail | PassingDetail

export interface StatusTableProps {
    statuses: StatusDetail[]
}

const columns: ColumnProps<StatusDetail>[] = [
    {
        key: 'status',
        title: '',
        render: (_, record) => {
            if (record.status === VeriflytResultStatus.NONE){
                return null;
            }
            if (record.status === VeriflytResultStatus.PASS){
                return <Icon type="check" style={{ color: 'green' }} />
            }
            return <Typography.Text type="danger"><Icon type="close" /></Typography.Text>
        },
        width: 20
    },
    {
        key: 'reason',
        title: 'Message',
        dataIndex: 'reason',
        render: (text, record) => {
            if (record.status === VeriflytResultStatus.PASS){
                return 'Requirement satisfied';
            }
            return text;
        }
    },
    {
        key: 'expiration',
        title: 'Expiration',
        render: (_, record) => {
            const expirationDate = momentOrNull(record.ticket?.expirationDate);
            const expDateString = expirationDate?.format('YYYY-MM-DD');

            if (!expirationDate){
                return 'N/A'
            }

            let text = `${expDateString}`;

            let secondaryText: React.ReactNode;

            const dayDelta = expirationDate.diff(moment(), 'days');

            if (dayDelta < 0){
                secondaryText = <Typography.Text type="danger">(EXPIRED)</Typography.Text>
            }
            else if (dayDelta === 0){
                secondaryText = <Typography.Text type="warning">(Expires TODAY)</Typography.Text>
            }
            else if (dayDelta < 7){
                secondaryText =  <Typography.Text type="warning">(Expires in {dayDelta} days)</Typography.Text>
            }
            else {
                secondaryText = <Typography.Text type="secondary">(Expires in {dayDelta} days)</Typography.Text>
            }

            return (
                <span>
                    {text} {secondaryText}
                </span>
            )
        }
    },
    {
        key: 'cert',
        title: 'Cert',
        render: (_, record) => (
            record.ticket?.onScreenName
        )
    },
    {
        key: 'rule',
        title: 'Rule',
        render: (_, record) => (
            record.rule?.onScreenName
        )
    }
]

export default function StatusTable(props: StatusTableProps){

    return <ETable
        size="small"
        className="mc-compliance-manager-status-table"
        columns={columns}
        dataSource={props.statuses}
        pagination={false}
    />
}